import React from 'react';
import DashboardStaff from './DashboardStaff';

/**
 * Dashboard para técnicos: estadísticas de tickets + accesos a
 * gestión de tickets y usuarios (sin proyectos ni ajustes, reservados a admin).
 */
const DashboardTecnico = ({ tokenInfo, onLinkClick }) => {
  return <DashboardStaff tokenInfo={tokenInfo} onLinkClick={onLinkClick} />;
};

export default DashboardTecnico;
